import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {blueColor} from "assets/jss/main";

TrackingNumber.propTypes = {
    trackingNumber: PropTypes.string.isRequired,
};

function TrackingNumber({trackingNumber, ...props}) {
    return (
        <b style={{ color: blueColor }}>
            {trackingNumber}
        </b>
    );
}

export default TrackingNumber;
